export const MerchantStatus = {
    NOT_SUBMITTED: 0,
    MERCHANT_PENDING: 1,
    PENDING_STRIPE: 6,
    VERIFIED: 2,
    ACTIVE: 3,
    CLOSED: 4,
    REJECTED: 5,
    WATCHLIST: 12
};
